module.exports = __webpack_public_path__ + "img/My Exchanges_1.eaba4ca9.svg";